import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../components/ContactUs/ContactUs.css";
import { submitContactEnquiry } from "../../API/Api";

const ContactUs = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        message: "",
    });

    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "phone") {
            const digitsOnly = value.replace(/\D/g, "");
            setFormData({ ...formData, [name]: digitsOnly });
        } else {
            setFormData({ ...formData, [name]: value });
        }

        setErrors({ ...errors, [name]: "" });
    };

    const validate = () => {
        const newErrors = {};
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const phoneRegex = /^[6-9]\d{9}$/;
        
        if (!formData.name.trim()) newErrors.name = "Name is required.";
        if (!formData.email.trim()) newErrors.email = "Email is required.";
        else if (!emailRegex.test(formData.email))
            newErrors.email = "Enter a valid email.";
        if (!formData.phone.trim()) newErrors.phone = "Phone is required.";
        else if (!phoneRegex.test(formData.phone))
            newErrors.phone = "Enter a valid 10-digit Indian phone number.";
        if (!formData.message.trim()) newErrors.message = "Message is required.";

        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate();
        
        if (Object.keys(validationErrors).length) {
            setErrors(validationErrors);
            return;
        }

        setIsSubmitting(true);

        try {
            await submitContactEnquiry({
                name: formData.name,
                email: formData.email,
                phone: formData.phone,
                message: formData.message
            });

            toast.success("Your message has been sent successfully!", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

            setFormData({
                name: "",
                email: "",
                phone: "",
                message: "",
            });
        } catch (error) {
            console.error("API Error:", error);
            toast.error(error.response?.data?.message || "Failed to send message. Please try again later.", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="about-page custom-container-upper font-poppins contact-container">
            {/* Toast Container */}
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            
            <div className="container custom-inner-space">
                <h2>CONTACT US</h2>
                <p>
                    You can directly call us on <strong>+91 7011588280</strong> or drop a
                    message. We will revert to your issue shortly.
                </p>

                <div className="contact-grid">
                    <div className="contact-map">
                        <iframe
                            title="stelmart-location"
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13012.712756979709!2d77.03177912081495!3d28.41786469147535!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d23c44392cdaf%3A0xcfb05827877d6707!2s58%2FG1!5e1!3m2!1sen!2sin!4v1749030447875!5m2!1sen!2sin"
                            width="100%"
                            height="100%"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                        />
                    </div>
                    <form className="contact-form" onSubmit={handleSubmit} noValidate>
                        <label>
                            Full Name *
                            <input
                                type="text"
                                name="name"
                                placeholder="Enter your full name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                            />
                            {errors.name && <span className="error-contact">{errors.name}</span>}
                        </label>

                        <label>
                            Email *
                            <input
                                type="email"
                                name="email"
                                placeholder="Enter your email address"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />
                            {errors.email && <span className="error-contact">{errors.email}</span>}
                        </label>

                        <label>
                            Phone Number *
                            <input
                                type="tel"
                                name="phone"
                                placeholder="Enter your 10-digit mobile number"
                                value={formData.phone}
                                onChange={handleChange}
                                maxLength="10"
                                required
                            />
                            {errors.phone && <span className="error-contact">{errors.phone}</span>}
                        </label>

                        <label>
                            What is your concern *
                            <textarea
                                name="message"
                                placeholder="Tell us about your concern and provide some details..."
                                value={formData.message}
                                onChange={handleChange}
                            ></textarea>
                            {/* {errors.message && <span className="error-contact">{errors.message}</span>} */}
                        </label>

                        <button type="submit" disabled={isSubmitting}>
                            {isSubmitting ? "Submitting..." : "Submit"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ContactUs;